import { useMutation, useQueryClient } from '@tanstack/react-query';
import { medicalRecordsApi } from '@/api';

export function useCreateClinicalEvolution() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: {
      medicalRecordId: string;
      doctorId: string;
      appointmentId: string;
      summary: string;
      conduct: string;
      observations?: string;
      nextAppointment?: string;
    }) => medicalRecordsApi.createClinicalEvolution(data),
    onSuccess: (newEvolution) => {
      queryClient.invalidateQueries({
        queryKey: ['medical-records', 'record', newEvolution.medicalRecordId],
      });
    },
  });
}
